var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var editor_2d = require('editor-2d');
var IpcImages = require("../../../../../shared/extensions/footprintGenerator/ipcImages/index.js");
if(typeof window !== 'undefined' )
    var ui_extensions = require("ui-extensions");
    
var QuadRowPackageGeneratorInteractionModel = require('../quadRowPackageGeneratorInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../../packageGeneratorInspectorConfig.js");

var PlccPadGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    QuadRowPackageGeneratorInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(PlccPadGeneratorInteractionModel, QuadRowPackageGeneratorInteractionModel);
PlccPadGeneratorInteractionModel.$class = 'PlccPadGeneratorInteractionModel';

module.exports = PlccPadGeneratorInteractionModel;

PlccPadGeneratorInteractionModel.prototype.initialize = function() {
	var self = this;

	QuadRowPackageGeneratorInteractionModel.prototype.initialize.call(this);

	this.terminalCenterToCenterDistance = this.shadow("terminalCenterToCenterDistance",
        function() {
            return self.data.terminalCenterToCenterDistance() / self.getUnitFactor();
        },
        function(value) {
            return self.data.terminalCenterToCenterDistance(parseFloat(value) * self.getUnitFactor());
        },
        [self.data.terminalCenterToCenterDistance, this.userSettingsModel.distanceUnit]
    );

    this.terminalCenterToCenterDistance2 = this.shadow("terminalCenterToCenterDistance2",
        function() {
            return self.data.terminalCenterToCenterDistance2() / self.getUnitFactor();
        },
        function(value) {
            return self.data.terminalCenterToCenterDistance2(parseFloat(value) * self.getUnitFactor());
        },
        [self.data.terminalCenterToCenterDistance2, this.userSettingsModel.distanceUnit]
    );
};

PlccPadGeneratorInteractionModel.prototype.getInspectorElementForPadCount = function() {
    var dPins = PackageGeneratorInspectorConfig.getTextbox(this.LCLZ('#DPins', '# Pins (D Side)'), this.verticalPadCount);
    var ePins = PackageGeneratorInspectorConfig.getTextbox(this.LCLZ('#EPins', '# Pins (E Side)'), this.horizontalPadCount);

    return [dPins, ePins];
};

PlccPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalCenterCenterDistance = function() {
    return [PackageGeneratorInspectorConfig.getValueFixedUnit('D2', this.LCLZ('terminalCCGap1', 'Terminal Center-Center Gap 1'), this.terminalCenterToCenterDistance, this.userSettingsModel.distanceUnit)];
};

PlccPadGeneratorInteractionModel.prototype.getInspectorElementForTerminalCenterCenterDistance2 = function() {
    return [PackageGeneratorInspectorConfig.getValueFixedUnit('E2', this.LCLZ('terminalCCGap2', 'Terminal Center-Center Gap 2'), this.terminalCenterToCenterDistance2, this.userSettingsModel.distanceUnit)];
};

PlccPadGeneratorInteractionModel.prototype.getInspectorElementForLeadSpan = function() {
    var span1 = PackageGeneratorInspectorConfig.getMinMaxRow('D', this.LCLZ('leadSpan1', 'Lead Span 1'), false, this.horizontalLeadToLeadSpanMin, false, this.horizontalLeadToLeadSpanMax, this.userSettingsModel.distanceUnit);
    var span2 = PackageGeneratorInspectorConfig.getMinMaxRow('E', this.LCLZ('leadSpan2', 'Lead Span 2'), false, this.verticalLeadToLeadSpanMin, false, this.verticalLeadToLeadSpanMax, this.userSettingsModel.distanceUnit);

    return [span1, span2];
};

PlccPadGeneratorInteractionModel.prototype.getInspectorElementForBodyWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E1', this.LCLZ('bodyWidth', 'Body Width'), false, this.bodyLengthMin, false, this.bodyLengthMax, this.userSettingsModel.distanceUnit)];
};

PlccPadGeneratorInteractionModel.prototype.getInspectorElementForBodyLength = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('D1', this.LCLZ('bodyLength', 'Body Length'), false, this.bodyWidthMin, false, this.bodyWidthMax, this.userSettingsModel.distanceUnit)];
};

//follows IPC type B zero orientation (see IPC7351 doc for details)
PlccPadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    //custom footprint settings
    if (this.withCustomFootprintParams() && this.showFootprintParams()) {
        imElements = imElements.concat(this.getInspectorElementForEnablingCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintImage(IpcImages.customFootprintPlcc));
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintNormalPadSettings());
        imElements = imElements.concat(this.getInspectorElementForPadSpan1InCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForPadSpan2InCustomFootprint());
    };
    imElements = imElements.concat(this.getInspectorElementForPadCount());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForPadRoundness());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForPitch());
    imElements = imElements.concat(this.getInspectorElementForTerminalCenterCenterDistance());
    imElements = imElements.concat(this.getInspectorElementForTerminalCenterCenterDistance2());
    imElements = imElements.concat(this.getInspectorElementForLeadSpan());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForBodyOffset());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForTolerance());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};